// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3SwDB","colMaxWidth":"Table_colMaxWidth__27KRp"};